/*
 * 用户登录相关api
 */

import { post, get, put, del } from 'api/http'

export default {
    // 用户登录
    login(data) {
        return post('/login', data, 'javaHost')
    },

    // 验证码登录
    loginByCode(data) {
        return get('/checkCodeLogin', data, 'javaHost')
    },

    // 公司登录
    companyLogin(data) {
        return post('/user/companyPermission', data, 'javaHost')
    },

    // 用户退出
    logout(data) {
        return get('/logout', data, 'javaHost')
    },

    // 微信服务绑定
    wxtoken(data) {
        return post('/wxtoken ', data)
    },

    // 注册时检测手机号是否已存在
    getExist(data) {
        return get('/checkMobile', data, 'javaHost')
    },

    // // 忘记密码时检测手机号是否已存在
    // getExistForForgetPwd(data) {
    //     return get('/app/forgot/check_mobile', data)
    // },

    // 获取登录验证码
    getLoginCode(data) {
        return get('/getCode', data, 'javaHost')
    },

    // 获取验证码
    getCode(data) {
        return get('/getCode', data, 'javaHost')
    },

    // 注册，开通账号获取密码
    register(data) {
        return post('/register', data, 'javaHost')
    },

    // 忘记密码接口
    forgetPwd(data) {
        return post('/forgetPwd', data, 'javaHost')
    },

    // 修改密码接口
    changePassword(data) {
        return get('/wx/user/updatePassword', data, 'javaHost')
    },

    // 修改手机号接口
    changeMobile(data) {
        return get('/wx/user/updateMobile', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js